import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MicrodistrictType } from "@app/api/microdistrict.api"
import { getAllMicrodistrictsThunk, getAllMicrodistrictsThunkFullfilled, getAllMicrodistrictsThunkPending, getAllMicrodistrictsThunkRejected } from './thunks/getAllMicrodistrictsThunk';
import { createMicrodistrictThunk, createMicrodistrictThunkFullfilled, createMicrodistrictThunkPending, createMicrodistrictThunkRejected } from './thunks/createMicrodistrictThunk';
import { deleteMicrodistrictThunk, deleteMicrodistrictThunkFullfilled, deleteMicrodistrictThunkPending, deleteMicrodistrictThunkRejected } from './thunks/deleteMicrodistrictThunk';

export interface GeoGuidMicrodistrictsStateType {
	microdistricts: MicrodistrictType[]
	microdistrict?: MicrodistrictType
	microdistrictsIsLoading: boolean
	createMicrodistrictIsLoading: boolean
	deleteMicrodistrictIsLoading: boolean
	deleteMicrodistrictIsSuccess: boolean
	showAddMicrodistrictModal: boolean
}

const initialState: GeoGuidMicrodistrictsStateType = {
	microdistricts: [],
	microdistrictsIsLoading: false,
	createMicrodistrictIsLoading: false,
	deleteMicrodistrictIsLoading: false,
	deleteMicrodistrictIsSuccess: false,
	showAddMicrodistrictModal: false,
}

const geoGuidMicrodistrictsSlice = createSlice({
	extraReducers: (build) => {
		build.addCase(getAllMicrodistrictsThunk.pending, getAllMicrodistrictsThunkPending)
		build.addCase(getAllMicrodistrictsThunk.rejected, getAllMicrodistrictsThunkRejected)
		build.addCase(getAllMicrodistrictsThunk.fulfilled, getAllMicrodistrictsThunkFullfilled)

		build.addCase(createMicrodistrictThunk.pending, createMicrodistrictThunkPending)
		build.addCase(createMicrodistrictThunk.rejected, createMicrodistrictThunkRejected)
		build.addCase(createMicrodistrictThunk.fulfilled, createMicrodistrictThunkFullfilled)

		build.addCase(deleteMicrodistrictThunk.pending, deleteMicrodistrictThunkPending)
		build.addCase(deleteMicrodistrictThunk.rejected, deleteMicrodistrictThunkRejected)
		build.addCase(deleteMicrodistrictThunk.fulfilled, deleteMicrodistrictThunkFullfilled)
	},
	initialState,
	name: "geoGuidMicrodistrictsSlice",
	reducers: {
		resetMicrodistrict(state) {
			state.microdistrict = undefined
		},
		resetDeleteMicrodistrictIsSuccess(state) {
			state.deleteMicrodistrictIsSuccess = false
		},
		setShowAddMicrodistrictModal(state, { payload }: PayloadAction<boolean>) {
			state.showAddMicrodistrictModal = payload
		},
	},
})

export default geoGuidMicrodistrictsSlice

export const { resetMicrodistrict, resetDeleteMicrodistrictIsSuccess, setShowAddMicrodistrictModal } = geoGuidMicrodistrictsSlice.actions
